import { Component, Inject } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../app.state';
import { addAnnex, updateAnnex } from '../../../calculation.actions';
import { rainSystemDefaultState } from '../rain-system/rain-system.constants';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AnnexModalDataInterface } from './annex.constants';
import { FormEvent } from '../../../../common/shared/constants';
import { RainSystemMeasurementsDto } from '../../../../../api/models/rain-system-measurements-dto';
import { MeasurementsType, SimpleRoofsMeasurementsType } from '../measurements.constants';
import { CalculationTypeEnum } from '../../../../../api/models/calculation-type-enum';

@Component({
  selector: 'annex-modal',
  templateUrl: './annex-modal.component.html',
  styleUrls: ['./annex-modal.component.scss'],
})
export class AnnexModalComponent {
  roofType: CalculationTypeEnum = this.data?.annex?.roofType ?? CalculationTypeEnum.OneSlope;
  roofTypes = CalculationTypeEnum;
  form = new UntypedFormGroup({});
  rainSystemFormEvent: FormEvent<RainSystemMeasurementsDto> = { valid: true, value: rainSystemDefaultState };
  measurementsFormEvent: FormEvent<MeasurementsType | null> = { valid: false, value: null };
  name = this.data?.annex?.name || '';
  rainSystem = false;

  constructor(@Inject(MAT_DIALOG_DATA) public data: AnnexModalDataInterface, private readonly store: Store<AppState>) {}

  setSlopes(roofType: CalculationTypeEnum) {
    this.roofType = roofType;
  }
  setRainSystem(rainSystem: FormEvent<RainSystemMeasurementsDto>) {
    this.rainSystemFormEvent = rainSystem;
  }
  setMeasurements(measurements: FormEvent<MeasurementsType>) {
    this.measurementsFormEvent = measurements;
  }

  addAnnex() {
    if (this.data === null) {
      return this.store.dispatch(
        addAnnex({
          annex: {
            measurements: this.measurementsFormEvent.value as SimpleRoofsMeasurementsType,
            roofType: this.roofType,
            rainSystem: this.rainSystemFormEvent.value,
            name: this.name,
          },
        }),
      );
    }
    return this.store.dispatch(
      updateAnnex({
        annex: {
          measurements: this.measurementsFormEvent.value as SimpleRoofsMeasurementsType,
          roofType: this.roofType,
          rainSystem: this.rainSystemFormEvent.value,
          name: this.name,
        },
        index: this.data.index,
      }),
    );
  }
}
